var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon3Dots(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.16667 10.3333C5.25 10.3333 4.5 11.0833 4.5 12C4.5 12.9167 5.25 13.6667 6.16667 13.6667C7.08333 13.6667 7.83333 12.9167 7.83333 12C7.83333 11.0833 7.08333 10.3333 6.16667 10.3333Z",
    fill: "#7E8299"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8332 10.3333C16.9165 10.3333 16.1665 11.0833 16.1665 12C16.1665 12.9167 16.9165 13.6667 17.8332 13.6667C18.7498 13.6667 19.4998 12.9167 19.4998 12C19.4998 11.0833 18.7498 10.3333 17.8332 10.3333Z",
    fill: "#7E8299"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 10.3333C11.0835 10.3333 10.3335 11.0833 10.3335 12C10.3335 12.9167 11.0835 13.6667 12.0002 13.6667C12.9168 13.6667 13.6668 12.9167 13.6668 12C13.6668 11.0833 12.9168 10.3333 12.0002 10.3333Z",
    fill: "#7E8299"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3Dots);
export default __webpack_public_path__ + "static/media/icon-3-dots.c853b6d1c87a5f4b6a1ce8034840724d.svg";
export { ForwardRef as ReactComponent };